import type { RootState } from "Store/store";
import { getRouteBasename } from "Utils";
import { whoamiApi } from "./whoami.api";

export const getCurrentUserEmail = (state: unknown) => {
  const { data } = whoamiApi.endpoints.getWhoami.select(undefined)(
    state as RootState,
  );
  return data?.email;
};

export const getWebsocketProtocolHost = () => {
  const protocol =
    PRODUCTION && location.hostname !== "localhost" ? "wss" : "ws";
  const basename = getRouteBasename();
  const host = basename ? `${location.host}${basename}` : `${location.host}`;
  return `${protocol}://${host}`;
};
